export const DUE_TAB = 1;
export const PAS_DUE_TAB = 2;
export const SYSTEM_LOGS_TAB = 3;
export const ALL_LOGS_TAB = 4;
